import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import { Col, Row, Table } from "reactstrap";
import {
  GET_RP_OVERUSE_CODE,
  GET_RP_OVERUSE_CODE_DATA,
} from "../../../helpers/url_api_constant";
import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function OveruseByContact(props) {
  // console.log(props);
  const dispatch = useDispatch();

  const [contactCount, setContactCount] = useState(0);
  const [overuseData, setOveruseData] = useState([]);

  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  useEffect(() => {
    fetchData();
  }, [props.summaryReportPid, props.shipperPid]);
  const fetchData = async () => {
    function compare(a, b) {
      if (a.PRIORITY_FLAG < b.PRIORITY_FLAG) {
        return -1;
      }
      if (a.PRIORITY_FLAG > b.PRIORITY_FLAG) {
        return 1;
      }
      return 0;
    }
    function compareArea(a, b) {
      if (a.OVERUSE_AREA < b.OVERUSE_AREA) {
        return -1;
      }
      if (a.OVERUSE_AREA > b.OVERUSE_AREA) {
        return 1;
      }
      return 0;
    }
    // dispatch(loadingAction.showLoading());
    try {
      let res2 = await post(GET_RP_OVERUSE_CODE, {
        SUMMARYREPORT_PID:
          props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
        OVERUSECODE_PID: props.shipperPid,
      });
      let [res1] = await Promise.all([
        post(GET_RP_OVERUSE_CODE_DATA, {
          OVERUSECODE_PID: res2?.data?.RPOversureShipperList[0].PID,
        }),
      ]);

      let data = res1.data.rpOveruseCodeDataList.map(row=>({...row,
        OVERUSE_ACTUAL: Math.round(row.OVERUSE_ACTUAL/1000),
        OVERUSE_BOOKING: Math.round(row.OVERUSE_BOOKING/1000),
        OVERUSE:Math.round(row.OVERUSE_ACTUAL/1000 )>Math.round(row.OVERUSE_BOOKING/1000 )? Math.round(row.OVERUSE_ACTUAL/1000 )-Math.round(row.OVERUSE_BOOKING/1000 ):0,
      }));

      let contactList = [
        ...new Set(data.map(item => item.OVERUSE_CONTACTCODE.trim())),
      ].sort();
      let entry = data
        .filter(item => item.OVERUSE_POINT.toLowerCase() == "entry")
        .sort(compare);
      let exit = data
        .filter(item => item.OVERUSE_POINT.toLowerCase() == "exit")
        .sort(compare);

      let entryData = entry
        .sort(compare)
        .reduce((r, a, index) => {
          let prevData = r.find(row => row.OVERUSE_AREA == a.OVERUSE_AREA);
          if (prevData != undefined) {
            r.map(row => {
              if (row.OVERUSE_AREA == prevData.OVERUSE_AREA) {
                row.data = [...row.data, a];
              }
              return row;
            });
          } else {
            r.push({
              OVERUSE_AREA: a.OVERUSE_AREA,
              data: [a],
              PRIORITY_FLAG: a.PRIORITY_FLAG,
            });
          }

          return r;
        }, [])
        .sort(compareArea);
      let tempEntryTotal = entry.sort(compare).reduce((r, a) => {
        r[a.OVERUSE_CONTACTCODE.trim()] = [
          ...(r[a.OVERUSE_CONTACTCODE.trim()] || []),
          a,
        ];
        return r;
      }, {});
      let entryTotal = [];
      Object.keys(tempEntryTotal).map(key => {
        let temp = tempEntryTotal[key].reduce(
          (total, row) => {
            total.OVERUSE_BOOKING = total.OVERUSE_BOOKING + row.OVERUSE_BOOKING;
            total.OVERUSE_ACTUAL = total.OVERUSE_ACTUAL + row.OVERUSE_ACTUAL;
            total.OVERUSE = total.OVERUSE + row.OVERUSE;
            total.PRIORITY_FLAG =
              tempEntryTotal[key][0].OVERUSE_CONTACTCODE.trim();
            return total;
          },
          {
            OVERUSE_BOOKING: 0,
            OVERUSE_ACTUAL: 0,
            OVERUSE: 0,
            PRIORITY_FLAG: 0,
          }
        );
        entryTotal.push(temp);
      });
      let exitData = exit
        .sort(compare)
        .reduce((r, a, index) => {
          let prevData = r.find(row => row.OVERUSE_AREA == a.OVERUSE_AREA);
          if (prevData != undefined) {
            r.map(row => {
              if (row.OVERUSE_AREA == prevData.OVERUSE_AREA) {
                row.data = [...row.data, a];
              }
              return row;
            });
          } else {
            r.push({
              OVERUSE_AREA: a.OVERUSE_AREA,
              data: [a],
              PRIORITY_FLAG: a.PRIORITY_FLAG,
            });
          }

          return r;
        }, [])
        .sort(compareArea);
      let tempExitTotal = exit.sort(compare).reduce((r, a) => {
        r[a.OVERUSE_CONTACTCODE.trim()] = [
          ...(r[a.OVERUSE_CONTACTCODE.trim()] || []),
          a,
        ];
        return r;
      }, {});
      let exitTotal = [];
      Object.keys(tempExitTotal).map(key => {
        let temp = tempExitTotal[key].reduce(
          (total, row) => {
            total.OVERUSE_BOOKING = total.OVERUSE_BOOKING + row.OVERUSE_BOOKING;
            total.OVERUSE_ACTUAL = total.OVERUSE_ACTUAL + row.OVERUSE_ACTUAL;
            total.OVERUSE = total.OVERUSE + row.OVERUSE;
            total.PRIORITY_FLAG =
              tempExitTotal[key][0].OVERUSE_CONTACTCODE.trim();
            return total;
          },
          {
            OVERUSE_BOOKING: 0,
            OVERUSE_ACTUAL: 0,
            OVERUSE: 0,
            PRIORITY_FLAG: 0,
          }
        );
        exitTotal.push(temp);
      });
      let contactCountList = data.map(item => contactList.length);

      let contactCountMax = 0;
      if (contactCountList.length)
        contactCountMax = Math.max(...contactCountList);
      setContactCount(contactCountMax);
      setOveruseData([
        {
          SHIPPER_NAME: props.shipperName,
          contacts: contactList,
          entry: entryData,
          entryTotal: entryTotal,
          exit: exitData,
          exitTotal: exitTotal,
        },
      ]);
    } catch (error) {
      // dispatch(messageAction.showMessage(error.message));
    }
    // dispatch(loadingAction.hideLoading());
  };

  const renderSubColumn = data => {
    const RowByData = () => {
      return data.contacts.map((contacts, index) => {
        return (
          <React.Fragment key={contacts}>
            <th
              style={{
                backgroundColor: index % 2 == 0 ? "#5868b785" : "#667eef85",
                color: "#FFFFFF",
                textAlign: "center",
                width: "20px",
                fontSize: "10px",
              }}
            >
              Booking
            </th>
            <th
              style={{
                backgroundColor: index % 2 == 0 ? "#5868b785" : "#667eef85",
                color: "#FFFFFF",
                textAlign: "center",
                width: "20px",
                fontSize: "10px",
              }}
            >
              Actual
            </th>
            <th
              style={{
                backgroundColor: index % 2 == 0 ? "#5868b785" : "#667eef85",
                color: "#FFFFFF",
                textAlign: "center",
                width: "20px",
                fontSize: "10px",
              }}
            >
              Overuse
            </th>
          </React.Fragment>
        );
      });
    };
    const RowByDummy = () => {
      let dummyList = [];
      if (contactCount != data.contacts.length) {
        let diff = contactCount - data.contacts.length;
        for (let i = 0; i < diff; i++) {
          dummyList.push(i);
        }
      }
      return dummyList.map((contacts, index) => {
        return (
          <React.Fragment key={index.toString()}>
            <th
              style={{
                backgroundColor: "#556ee678",
                color: "#FFFFFF",
                textAlign: "center",
                width: "20px",
                fontSize: "10px",
              }}
            ></th>
            <th
              style={{
                backgroundColor: "#556ee678",
                color: "#FFFFFF",
                textAlign: "center",
                width: "20px",
                fontSize: "10px",
              }}
            ></th>
            <th
              style={{
                backgroundColor: "#556ee678",
                color: "#FFFFFF",
                textAlign: "center",
                width: "20px",
                fontSize: "10px",
              }}
            ></th>
          </React.Fragment>
        );
      });
    };
    return (
      <>
        <RowByData />
        <RowByDummy />
      </>
    );
  };

  const renderTotalByRow = (data, item) => {
    let totalBooking = 0;
    let totalActual = 0;
    let total = 0;
    data.map((value, index) => {
      totalBooking += value.OVERUSE_BOOKING;
      totalActual += value.OVERUSE_ACTUAL;
      total += value.OVERUSE;
    });
    const Total = () => {
      return data
        .sort((a, b) =>
          a.PRIORITY_FLAG > b.PRIORITY_FLAG
            ? 1
            : b.PRIORITY_FLAG > a.PRIORITY_FLAG
              ? -1
              : 0
        )
        .map((value, index) => {
          return (
            <React.Fragment key={index.toString()}>
              <td>
                <p>{numberFormat(value.OVERUSE_BOOKING , 0)}</p>
              </td>
              <td>
                <p>{numberFormat(value.OVERUSE_ACTUAL , 0)}</p>
              </td>
              <td style={{...(value.OVERUSE  ).toFixed(0)>0&&({color: 'rgb(240, 20, 6)'})}}>
                <p>{numberFormat(value.OVERUSE , 0)}</p>
              </td>
            </React.Fragment>
          );
        });
    };
    const RowByDummy = () => {
      let dummyList = [];
      if (contactCount != item.contacts.length) {
        let diff = contactCount - item.contacts.length;
        for (let i = 0; i < diff; i++) {
          dummyList.push(i);
        }
      }
      return dummyList.map((contacts, index) => {
        return (
          <React.Fragment key={index.toString()}>
            <td></td>
            <td></td>
            <td></td>
          </React.Fragment>
        );
      });
    };
    return (
      <>
        <Total />
        <RowByDummy />
        <td>
          <p>{numberFormat(totalBooking , 0)}</p>
        </td>
        <td>
          <p>{numberFormat(totalActual , 0)}</p>
        </td>
        <td style={{...(total  ).toFixed(0)>0&&({color: 'rgb(240, 20, 6)'})}}>
          <p>{numberFormat(total , 0)}</p>
        </td>
      </>
    );
  };
  const DummyContact = item => {
    let dummyList = [];
    if (contactCount != item.contacts.length) {
      let diff = contactCount - item.contacts.length;
      for (let i = 0; i < diff; i++) {
        dummyList.push(i);
      }
    }
    return dummyList.map((dummy, index) => {
      return (
        <React.Fragment key={index.toString()}>
          <th
            colSpan={3}
            style={{
              backgroundColor: "#556ee678",
              color: "#FFFFFF",
              textAlign: "center",
              fontSize: "10px",
            }}
          ></th>
        </React.Fragment>
      );
    });
  };
  const DummyData = item => {
    let dummyList = [];
    if (contactCount != item.length) {
      let diff = contactCount - item.length;
      for (let i = 0; i < diff; i++) {
        dummyList.push(i);
      }
    }
    return dummyList.map((dummy, index) => {
      return (
        <React.Fragment key={index.toString()}>
          <td></td>
          <td></td>
          <td></td>
        </React.Fragment>
      );
    });
  };
  const OveruseByContact = (data, contacts) => contacts.map((contact, index) => {
    let dataByContact = data.find(obj => obj.OVERUSE_CONTACTCODE == contact)
    if (dataByContact) {
      return (
        <React.Fragment key={dataByContact.PID}>
          <td>
            <p>
              {numberFormat(dataByContact.OVERUSE_BOOKING , 0)}
            </p>
          </td>
          <td>
            <p>
              {numberFormat(dataByContact.OVERUSE_ACTUAL , 0)}
            </p>
          </td>
          <td style={{...(dataByContact.OVERUSE  ).toFixed(0)>0&&({color: 'rgb(240, 20, 6)'})}}>
            <p>{numberFormat(dataByContact.OVERUSE , 0)}</p>
          </td>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment key={index.toString()}>
          <td></td>
          <td></td>
          <td></td>
        </React.Fragment>
      );
    }
  })
  const renderOveruseData = (data, contact) => {
    let totalBooking = 0;
    let totalActual = 0;
    let total = 0;
    data = data
      .sort((a, b) =>
        a.OVERUSE_CONTACTCODE > b.OVERUSE_CONTACTCODE
          ? 1
          : b.OVERUSE_CONTACTCODE > a.OVERUSE_CONTACTCODE
            ? -1
            : 0
      )
    data.map(value => {
      totalBooking += value.OVERUSE_BOOKING;
      totalActual += value.OVERUSE_ACTUAL;
      total += value.OVERUSE;
    })
    return (
      <React.Fragment >
        {OveruseByContact(data, contact)}
        <td>
          <p>{numberFormat(totalBooking , 0)}</p>
        </td>
        <td>
          <p>{numberFormat(totalActual , 0)}</p>
        </td>
        <td style={{...(total ).toFixed(0)>0&&({color: 'rgb(240, 20, 6)'})}}>
          <p>{numberFormat(total , 0)}</p>
        </td>
      </React.Fragment>)


  };


  return (
    <div>
      {props.shipperName != "TSO" && (
        <div className="table-responsive">
          <Table className="table table-bordered mb-0">
            {overuseData.map(item => {
              return (
                <React.Fragment key={item.SHIPPER_NAME}>
                  <thead>
                    <tr>
                      <th
                        colSpan={contactCount * 3 + 4}
                        style={{
                          backgroundColor: "#556ee678",
                          color: "#FFFFFF",
                          textAlign: "center",
                          width: "100%",
                        }}
                      >
                        {item.SHIPPER_NAME}
                      </th>
                    </tr>
                    <tr>
                      <th
                        rowSpan={3}
                        style={{
                          backgroundColor: "#556ee678",
                          color: "#FFFFFF",
                          textAlign: "center",
                          fontSize: "10px",
                        }}
                      >
                        Area
                      </th>
                    </tr>
                    <tr>
                      {item.contacts.map((contact, index) => {
                        return (
                          <th
                            key={contact}
                            colSpan={3}
                            style={{
                              backgroundColor:
                                index % 2 == 0 ? "#5868b785" : "#667eef85",
                              color: "#FFFFFF",
                              textAlign: "center",
                              fontSize: "10px",
                            }}
                          >
                            {contact}
                          </th>
                        );
                      })}
                      {DummyContact(item)}
                      <th
                        colSpan={3}
                        style={{
                          backgroundColor: "#556ee678",
                          color: "#FFFFFF",
                          textAlign: "center",
                          fontSize: "10px",
                        }}
                      >
                        Total
                      </th>
                    </tr>
                    <tr>
                      {renderSubColumn(item)}
                      <th
                        style={{
                          backgroundColor: "#556ee678",
                          color: "#FFFFFF",
                          textAlign: "center",
                          width: "20px",
                          fontSize: "10px",
                        }}
                      >
                        Booking
                      </th>
                      <th
                        style={{
                          backgroundColor: "#556ee678",
                          color: "#FFFFFF",
                          textAlign: "center",
                          width: "20px",
                          fontSize: "10px",
                        }}
                      >
                        Actual
                      </th>
                      <th
                        style={{
                          backgroundColor: "#556ee678",
                          color: "#FFFFFF",
                          textAlign: "center",
                          width: "20px",
                          fontSize: "10px",
                        }}
                      >
                        Overuse
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
                    {item.entry.map(obj => {
                      let totalBooking = 0;
                      let totalActual = 0;
                      let total = 0;
                      return (
                        <tr key={obj.OVERUSE_AREA}>
                          <td>{obj.OVERUSE_AREA}</td>
                          {renderOveruseData(obj.data, item.contacts)}
                        </tr>
                      );
                    })}

                    <tr style={{ backgroundColor: "#556ee630" }}>
                      <td>Total</td>
                      {renderTotalByRow(item.entryTotal, item)}
                    </tr>
                    {item.exit.map(obj => {
                      let totalBooking = 0;
                      let totalActual = 0;
                      let total = 0;
                      return (
                        <tr key={obj.OVERUSE_AREA}>
                          <td>{obj.OVERUSE_AREA}</td>
                          {renderOveruseData(obj.data, item.contacts)}

                        </tr>
                      );
                    })}
                    <tr style={{ backgroundColor: "#556ee630" }}>
                      <td>Total</td>
                      {renderTotalByRow(item.exitTotal, item)}
                    </tr>
                  </tbody>
                </React.Fragment>
              );
            })}
          </Table>
        </div>
      )}
    </div>
  );
}

OveruseByContact.propTypes = {
  t: PropTypes.any,
  summaryReportPid: PropTypes.any,
  shipperPid: PropTypes.any,
  shipperName: PropTypes.any,
};

export default OveruseByContact;
